import classNames from 'classnames'
import React, { SFC } from 'react'
import { TranslationFunction } from 'react-i18next'

import { i18nKeys } from '../../app.i18n'
import { identity } from '../../shared'
import { PaginationInfo } from '../smart-table'

type OwnProps = { translate?: TranslationFunction; className?: string }

type Props = OwnProps & PaginationInfo

const PaginationSummary: SFC<Props> = ({
  actualPage,
  numberOfItemsShown,
  numberOfAllItems,
  pageSize,
  translate = identity,
  className,
}) => {
  return (
    <div className={classNames(className)}>
      {translate(i18nKeys.shared.pagination.paginationInfo, {
        from: getShownFrom(actualPage, pageSize),
        to: getShowTo(actualPage, pageSize, numberOfItemsShown),
        all: numberOfAllItems,
      })}
    </div>
  )
}

function getShownFrom(currentPage: number, pageSize: number) {
  if (currentPage === 1) {
    return currentPage
  }

  return (currentPage - 1) * pageSize + 1
}

function getShowTo(currentPage: number, pageSize: number, numberOfItemsShown: number) {
  if (currentPage === 1) {
    return numberOfItemsShown
  }

  return (currentPage - 1) * pageSize + numberOfItemsShown
}

export { PaginationSummary }



// WEBPACK FOOTER //
// ./src/app/shared/pagination/pagination-summary.tsx